import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ருக் உபாகர்மா</h1>
  <mat-tab-group  mat-stretch-tabs >
    <mat-tab label="தமிழ்">
      <p class="svk">ஆசமனம்</p>
  <div class="hint">ஆசமனம், ப்ராணாயாமம் அடிக்கடி
    செய்யவேண்டியிருக்கும், எனவே, இதை நன்றாகத்
    தெரிந்து வைத்துக்கொண்டு கர்மாவைச் செய்தால்
    விரைவாகவும், சிறப்பாகவும் செய்யலாம்.
    </div>
  <hr>
  <div>
    <img src="assets/img/achamanam.gif">
  </div>
  <div class="svk2">Achamanam - Audio </div>
      <audio controls>
      <source src="http://www.brahminsnet.com/upakarma/audio/achamanam.ogg" type="audio/ogg">
        <source src="http://www.brahminsnet.com/upakarma/audio/mp4/achamanam.mp4" type="audio/mp4">
    Your browser does not support the audio element.
    </audio>
  <div class="hint">ஒரு நாளில், ஒரு கர்மாவின்
    ஆரம்பத்திலும், முடிவிலும் இரண்டு முறை
    ஆசமனம் செய்யவேண்டும். இடையிடையே
    ஒவ்வொரு முறை செய்தால் போறும்.
    </div>
    <hr>
  <div class="sans">
    ओं अच्युताय नम:। ओं अनन्ताय नम:। <br>
    ओं गोविन्दााय नम:।<br>
    <ion-grid>
      <ion-row>
        <ion-col class="sans">ओं केशवाय नम:। </ion-col>
        <ion-col class="sans">नारायणाय नम:।</ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">माधवाय नम:।</ion-col>
        <ion-col class="sans">गोविन्दाय नम:।</ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">विष्णवे नम:। </ion-col>
        <ion-col class="sans">मधुसूदनाय नम:।
         </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans"> त्रिविक्रमाय नम:। </ion-col>
        <ion-col class="sans">वामनाय नम:।
          </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">श्रीधराय नम:। </ion-col>
        <ion-col class="sans">हृषीकेशाय नम:।
          </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="sans">पद्मनाभाय नम:। </ion-col>
        <ion-col class="sans">दामोदराय नम:।</ion-col>
      </ion-row>
    </ion-grid>
     </div>
  <hr>
  <div>
      <img src="assets/img/Praanaayaamam1.jpg" class="img2">

      <div class="hint">மணையில் இரு தர்பங்களை ஆசனமாகப்
        போட்டுக்கொண்டு, அதன்மேல் கிழக்கு நோக்கி அமரவும்.
        </div>
    </div>
    <hr>
    <div>
      <img src="assets/img/Praanaayaamam2.jpg" class="img2">

      <div class="hint">இரு தர்பங்களாலான பவித்திரத்தை,
        வலது மோதிர விரலில் அணிந்து, அதனுடன் இரு
        தர்பங்களைச் சேர்த்து இடுக்கிக்கொள்ளவும்.
        </div>
    </div>
    <p class="clear"></p><hr>


    <div>
      <img src="assets/img/Praanaayaamam3.jpg" class="img2">

      <div class="hint">வலது மூக்குத் துவாரத்தை, வலது
        கட்டை விரலால் அழுத்தி அடைக்கவும்.
      </div>
    </div>

    <p class="clear"></p><hr>
    <div>
      <img src="assets/img/Praanaayaamam4.jpg" class="img2">
      <div class="hint"> வாயை நன்கு மூடி,
        சுட்டு விரல், நடு விரல்களை உள்ளே மடித்து,
        இட மூக்குத் துவாரம் வழியாக, வெளிக்காற்றை,
        முடிந்தவரை உள்ளிழுத்து நிறுத்தி,
        மோதிர, சுண்டு விரல்களால், இடமூக்குத் துவாரத்தையும்
        நன்கு அடைத்து ப்ராணாயாம மந்திரத்தை 3 முறை சொல்லவும்.
        </div>
    </div>
    <p class="clear"></p><hr>
    <div class="svk2">Pranayamam - Audio </div>
    <audio controls>
    <source src="http://www.brahminsnet.com/upakarma/audio/03-pranayamam1.ogg" type="audio/ogg">
      <source src="http://www.brahminsnet.com/upakarma/audio/mp4/03-pranayamam1.mp4" type="audio/mp4">
  Your browser does not support the audio element.
  </audio>
    <div class="prayogam">
      ஓம் பூ: ஓம் புவ: ஓகும்ஸுவ: ஓம் மஹ: ஓம் ஜன: ஓம் தப: ஓம் ஸத்யம்,
      தத்ஸவிதுர்வரேண்யம் பர்கோதேவஸ்யதீமஹி தியோயோந:ப்ரசோதயாத் ஓமாப: ஜ்யோதீரஸ:
     அம்ருதம் ப்ரஹ்மா பூர்புவஸ்ஸுவரோம்.
    </div>
  <hr>
  <div class="head2">ப்ராணாயாமம்</div>
  <hr>
  <div class="sans">
    ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
    ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
  </div>
 <hr>

  <div>
    <img src="assets/img/praanaayaamam.gif">
  </div>


  <div class="item">வடகலை ஆரம்பம்</div>
<hr>
  <div>
    <img src="assets/img/kaikoopu.jpg" class="img2">
    <div class="hint">கையைக் கூப்பிக்கொண்டு
      மந்திரங்களைச் சொல்ல ஆரம்பிக்கவும்.
    </div>
  </div>
<hr>
<div class="svk2">VK-Begin - Audio </div>
      <audio controls>
      <source src="http://www.brahminsnet.com/upakarma/audio/04-vkbegining.ogg" type="audio/ogg">
        <source src="http://www.brahminsnet.com/upakarma/audio/mp4/04-vkbegining.mp4" type="audio/mp4">
    Your browser does not support the audio element.
    </audio>
  <div class="prayogam">ஓம் அஸ்மத் குருப்யோ நம: ஸ்ரீமான் வேங்கட நாதார்ய:
     கவிதார்கிக கேசரி வேதாந்தாசார்ய வர்யோமே ஸந்நிதத்தாம்
     ஸதாஹ்ருதி குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே
     வ்ருணீமஹேச தத்ராத்யௌ தம்பதி ஜகதாம்பதி ஸ்வசேஷ
     பூதேநமயா ஸ்வீயை: ஸர்வபரிச்சதை:
    விதாதும் ப்ரீதமாத்மாநம் தேவ: ப்ரக்ரமதே ஸ்வயம்.</div>
    <hr>
  <div class="sans">
    ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
    नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
    देव: प्रक्रमते स्वयम् ।।

  </div>
  <hr>
  <div class="item">தென்கலை, ஸ்மார்த்தா ஆரம்பம் வடகலை தொடர்ச்சி</div>
  <div class="svk2">Suklambaradharam - Audio </div>
  <audio controls>
  <source src="http://www.brahminsnet.com/upakarma/audio/05-suklambara.ogg" type="audio/ogg">
    <source src="http://www.brahminsnet.com/upakarma/audio/mp4/05-suklambara.mp4" type="audio/mp4">
Your browser does not support the audio element.
</audio>
  <div class="prayogam">
      சுக்லாம்பரதரம் விஷ்ணும் சசிவர்ணம் சதுர்புஜம் ப்ரஸன்னவதனம்
      த்யாயேது ஸர்வவிக்னோபசாந்தயே யஸ்யத்விரத வக்த்ராத்யா:
      பாரிஷத்யா:       பரஸ்சதம் விக்னம் நிக்னந்தி சததம்
      விஷ்வக்ஸேனம் தமாச்ரயே.
  </div>
  <hr>
  <div class="sans">
    शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
    पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।

  </div>
<hr>
  <div>
    <img src="assets/img/Sankalpam.jpg" class="img2">
    <div class="hint">வலது தொடையில் இடதுகைமேல்
      வலது கைவைத்து</div>
  </div>

  <p class="clear"></p><hr>
  <div class="prayogam"> ஹரிரோம்தத்<br />
    ஸ்ரீ கோவிந்தா கோவிந்த கோவிந்தா அஸ்யஸ்ரீ பகவத: மஹாபுருஷ்ஸ்ய
     விஷ்ணோராஜ்ஞயா ப்ரவர்த்தமானஸ்ய ஆத்ய ப்ரஹ்மண:
     த்விதீயபரார்த்தே
    ஸ்ரீ ஸ்வேதவராஹ கல்பே வைவஸ்வத மன்வந்தரே
    கலியுகே ப்ரதமே பாதே
  </div>
  <div class="svk2">HariromTat - Audio </div>
  <audio controls>
  <source src="http://www.brahminsnet.com/upakarma/audio/06-gensankalpam.ogg" type="audio/ogg">
    <source src="http://www.brahminsnet.com/upakarma/audio/mp4/06-gensankalpam.mp4" type="audio/mp4">
Your browser does not support the audio element.
</audio>

  <div class="svk">இந்தியாவில் இருப்பவர்கள்</div>
  <div class="prayogam"> ஜம்பூத்வீபே பாரதவர்ஷே பரதக்கண்டே

  </div>

  <div class="svk">
      வெளிநாட்டில் இருப்பவர்கள் :
      த்வீபம் வர்ஷம் கண்டம் தெரியாதவர்கள் “விஷ்ணு” என்பதை
      உபயோகித்துக்கொள்ளலாம். அதாவது “விஷ்ணு த்வீபே”
      “விஷ்ணு வர்ஷே”, “விஷ்ணு கண்டே” என்று சொல்லலாம்

  </div>
<hr>
  <div class="svk">எல்லோரும் சொல்லவும்</div>
  <div class="prayogam">சகாப்தே மேரோ: தக்ஷிணே பார்சவே அஸ்மின்
    வர்தமானானாம் வ்யவஹாரிகானாம் ப்ரபவாதீநாம் ஷஷ்டி
    ஸம்வத்ஸராணாம் மத்யே
    .....</div>
    <hr>
  <div class="sans">
    हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
    श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
    अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
  </div>
  <p class="clear"></p>

<hr>
  <div class="head2">
    11-08-2022 க்கான ஸங்கல்பம்:
  </div>
  <div class="svk2">11-08-2022-Sankalpam - Audio </div>
    <audio controls>
    <source src="http://www.brahminsnet.com/upakarma/audio/11-08-2022.ogg" type="audio/ogg">
      <source src="http://www.brahminsnet.com/upakarma/audio/mp4/11-08-2022.mp4" type="audio/mp4">
  Your browser does not support the audio element.
  </audio>
  <hr>

  <div class="prayogam">சுபக்ருது நாம ஸம்வத்ஸரே - தக்ஷிணாயனே - க்ரீஷ்ம ருதௌ -
    கடக மாஸே - சுக்ல பக்ஷே -சதுர்தஸ்யாம் (10.14 am)/ பௌர்ணமாஸ்யாம் சுப திதௌ -
    வாஸர: குரு வாஸர யுக்தாயாம்
    - உத்ராஷாடா(6.55am) / ச்ரவண  நக்ஷத்ர யுக்தாயாம் -
    ஆயுஷ்மான் யோக யுக்தாயாம் - வணிஜ(10.14am)/பத்ர கரண யுக்தாயாம் - ஏவங்குண, விசேஷண விசிஷ்டாயாம் - அஸ்யாம்
    பௌர்ணமாஸ்யாம் சுப திதௌ
  </div>
  <hr>
  <div class="sans">
    .... शुभकृतु नाम संवत्सरे दक्षिणयने - ग्रीष्म ऋतौ   कटक मासे शुक्ल पक्षे चतुर्तस्यां (10.14am)/ पौर्णमास्याम् शुभ तिथौ वासर:
        गुरु वासर युक्तायां 
        उत्तराषाडा(6.55am) / श्रवण नक्षत्र युक्तायां आयुष्मान् योग युक्तायां वणिज (10.14am) /भत्र करण युक्तायां एवङ्गुण विशेषण विशिष्टायां अस्यां पौर्णमास्याम् शुभ
         तिथौ श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं
  </div>


     <div class="mydiv">ஸ்ரீ-ம் (குறிப்பு:- இதுபோல் ஸ்ரீ-ம் என்று உள்ள இடங்களிலெல்லாம்
    <br> வடகலையார் ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீமந் நாராயண ப்ரீத்யர்த்தம் என்றும்,
    <br> தென்கலையார் ஸ்ரீபகவதாஜ்ஞயா ஸ்ரீபகவத் கைங்கர்யம் என்றும்,
    <br> ஸ்மார்த்தா மமோ பார்த்த சமஸ்த துரிதக்ஷய த்வாரா
    ஸ்ரீ பரமேஸ்வர ப்ரீத்யர்த்தம் என்றும் சொல்லிக் கொள்ளவும்) </div>
    <p class="clear"></p>

<hr>
  <p class="head2">யஜ்ஞோபவீத தாரண ஸங்கல்பம்: </p>
<hr>
  <div class="prayogam">மம ச்ரௌத ச்மார்த்த விதி விஹித நித்ய கர்மாநுஷ்டாந யோக்யதா ஸித்தியர்த்தம் ப்ரஹ்ம தேஜ: அபிவ்ருத்தியர்த்தம் யஜ்ஞோபவீத தாரணம்
    கரிஷ்யே. </div>
<div class="sans">
    मम श्रौतस्मार्त वितिविहित न्त्यिकर्म अनुष्टान योग्यता सिध्यर्थं ब्रह्मतेज:
    अभिवृद्धयर्थं यज्ञोपवीत धारणं करिष्ये।
</div>

<hr>
  <p class="head2">யஜ்ஞோபவீத தாரண ந்யாஸம்:</p>
<hr>
<div>
    <img src="assets/img/Nyaasam1.jpg" class="img2">

    <div class="hint">தலையைத் தொட்டு :</div>
    <div class="prayogam">யஜ்ஞோபவீத தாரண மந்த்ரஸ்ய ப்ரும்மா ருஷி:</div>
    <div class="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
  </div>

  <p class="clear"></p><hr>

  <div>
    <img src="assets/img/Nyaasam2.jpg" class="img2">

    <div class="hint">மூக்கைத் தொட்டு :-</div>
    <div class="prayogam">‘அநுஷ்டுப் சந்த:’</div>
    <div class="sans">अनुष्टुप् छन्द:</div>

  </div>
  <p class="clear"></p><hr>



  <div>
    <img src="assets/img/Nyaasam3.jpg" class="img2">
    <div class="hint">மார்பைத் தொட்டு :-</div>
    <div class="prayogam">‘த்ரயீ வித்யா தேவதா’</div>
    <div class="sans">त्रयीविद्या देवता</div>

  </div>
  <hr>

  <div>
    <img src="assets/img/Nyaasam4.jpg" class="img2">

    <div class="hint">இரு கைகளையும் உட்புறமாகத் திருப்பி:</div>
    <div class="prayogam"> ‘யஜ்ஞோபவீத தாரணே விநியோக:’</div>
    <div class="sans">यज्ञोपवीत धारणे विनियोग:</div>
  </div>
 <p class="head2">யஞ்ஞோபவீத தாரணம் </p>
<hr>
<img src="assets/img/Poonal-BrahmaMudichu.jpg">
<hr>
  <div>
      <img src="assets/img/poonal-position.jpg" class="img2">

      <div class="hint">(பூணலில் ப்ரம்ம முடிச்சின் பசுமுகம் போன்ற இரண்டு
        நுனிகளுடன் கூடிய பாகம் கட்டைவிரலை பார்த்திருக்கும்படி வலது கையில் வைத்து,
    இடது கையால் பூணலின் கீழ்ப் பாகத்தின் உள்ளே வைத்து
    தளர்வின்றி பிடித்துக்கொண்டு மந்திரம் முடிந்தவுடன் தலையில் மாட்டி வலதுகை
    உள்ளே நுழைத்து இடது கையை வெளியே எடுத்துவிடவும்) </div>
</div>
<p class="clear"></p>
<hr>
<div>
    <img src="assets/img/insert-poonal.jpg" class="img2">

  <div class="prayogam">யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதே:
    யத்ஸஹஜம் புரஸ்தாது ஆயுஷ்யம் அக்ரியம் ப்ரதிமுஞ்ச சுப்ரம்
    யஜ்ஞோபவீதம் பலமஸ்து தேஜ: </div>
</div>
<p class="clear"></p>
<div class="sans">
    यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
    अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
</div>

  <div class="hint"> என்று சொல்லி போட்டுக்கொள்ளவேண்டியது.</div>
  <div class="hint"> (என்று சங்கல்பித்து) இடுக்கு தர்பம் இருந்தால் அதை
    வடக்கே (இடது புறம்) சேர்க்கவும். </div>
    <div class="svk2">Yajgnopaveeta-Sankalpam - Audio </div>
  <audio controls>
  <source src="http://www.brahminsnet.com/upakarma/audio/17-yagnopaveethasankalpam.ogg" type="audio/ogg">
    <source src="http://www.brahminsnet.com/upakarma/audio/mp4/17-yagnopaveethasankalpam.mp4" type="audio/mp4">
Your browser does not support the audio element.
</audio>
  <hr>
  <div>
      <img src="assets/img/pavithram-in-ear.jpg" class="img2">
      <div class="hint">(கல்யாணமானவர்கள் மட்டும் 2வது பூணலுக்கு
         பவித்ரம் காதில் வைத்து
     ஆசமனம் பண்ணி பின் பவித்ரம்
    போட்டு ப்ராணாயமம்)</div>
    </div>
    <p class="clear"></p>
<hr>
<div>
<img src="assets/img/praanaayaamam.gif">
</div>

<hr>
  <div><img src="assets/img/sankalpam.jpg" class="img2">
  <div class="prayogam">ஸ்ரீ-ம் க்ருஹஸ்த ஆச்ரமார்த்தம் த்விதீய யஜ்ஞோபவீத
     தாரணம் கரிஷ்யே. </div>
     <div class="sans">
        ग्रहस्त आश्रमार्थं िद्वतीय यज्ञोपवीत धारणं करिष्ये।
     </div>
     </div>
<hr>
<div>
    <img src="assets/img/poonal-position.jpg" class="img2">

    <div class="hint">(பூணலில் ப்ரம்ம முடிச்சின் பசுமுகம் போன்ற இரண்டு
      நுனிகளுடன் கூடிய பாகம் கட்டைவிரலை பார்த்திருக்கும்படி வலது கையில் வைத்து,
  இடது கையால் பூணலின் கீழ்ப் பாகத்தின் உள்ளே வைத்து
  தளர்வின்றி பிடித்துக்கொண்டு மந்திரம் முடிந்தவுடன் தலையில் மாட்டி வலதுகை
  உள்ளே நுழைத்து இடது கையை வெளியே எடுத்துவிடவும்) </div>
</div>
<p class="clear"></p>
<hr>
<div>
  <img src="assets/img/insert-poonal.jpg" class="img2">

<div class="prayogam">யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதே:
  யத்ஸஹஜம் புரஸ்தாது ஆயுஷ்யம் அக்ரியம் ப்ரதிமுஞ்ச சுப்ரம்
  யஜ்ஞோபவீதம் பலமஸ்து தேஜ: </div>
</div>
<p class="clear"></p>
<div class="sans">
  यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
  अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
</div>

<div class="hint"> என்று சொல்லி போட்டுக்கொள்ளவேண்டியது.</div>
<div class="hint"> (என்று சங்கல்பித்து) இடுக்கு தர்பம் இருந்தால் அதை
  வடக்கே (இடது புறம்) சேர்க்கவும். </div>
  <div class="svk2">Gruhasta-2nd-Poonal - Audio </div>
<audio controls>
<source src="http://www.brahminsnet.com/upakarma/audio/18-2ndpoonal.ogg" type="audio/ogg">
  <source src="http://www.brahminsnet.com/upakarma/audio/mp4/18-2ndpoonal.mp4" type="audio/mp4">
Your browser does not support the audio element.
</audio>
<hr>



  <div class="hint"> பின் க்ருஹஸ்தாள் ப்ருஹ்மச்சாரி அனைவரும் </div>
  <div class="prayogam">"உபவீதம் பின்னதந்தும் ஜீர்ணம் கஸ்மலதூஷிதம்
    விஸ்ருஜாமி ஜலேப்ரஹ்மண்ணு வர்ச்ச: தீர்காயு: அஸ்துமே"</div>
    <div class="sans">
        उपवीतं भिन्नतन्तुं जीर्णं कश्मलदूषितम्।<br>
        विसृजामि जले ब्रह्मन् वर्च: दीर्घायु: अस्तु मे।।
    </div>
    <div class="svk2">Remove Old Poonal - Audio </div>
    <audio controls>
    <source src="http://www.brahminsnet.com/upakarma/audio/19-removepoonal.ogg" type="audio/ogg">
      <source src="http://www.brahminsnet.com/upakarma/audio/mp4/19-removepoonal.mp4" type="audio/mp4">
    Your browser does not support the audio element.
    </audio>
<hr>

<div>
    <img src="assets/img/pavithram-in-ear.jpg" class="img2">
  <div class="hint"> என்று சொல்லி பழைய பூணலை எடுத்துவிட்டு பவித்ரம்
    காதில் வைத்து ஆசமனம் பண்ணவும். </div>
    </div>
    <img src="assets/img/achamanam.gif">
    <div class="mydiv">
    <div class="svk">ருக் வேதிகளுக்கு
    கமோகார்ஷீத் ஜபம் கிடையாது.</div>
</div>
<p class="clear"></p>


  <div class="hint">பவித்ரம் காதில் இருந்தால் போட்டுக்கொள்ளவும்.</div>
    <hr>

     <div>
      <img src="assets/img/Sankalpam.jpg" class="img2">
      <div class="hint">வலது தொடையில் இடதுகைமேல் வலது கைவைத்து</div>
      </div>

      <h2>உபாகர்மா மண்டல தேவதா தர்பணம்</h2>
      <h3> மண்டல தேவதா தர்பணம் உபாகர்மாவின் முக்கிய பாகமாகும். சாஸ்த்ரப்படி நதி, குளம் போன்ற நீர் நிலைக்குச் சென்று (சிலர் ஸ்நாந மஹா சங்கல்பமும் செய்துகொள்வர்) அமிழ்ந்து தீர்த்தமாடி, மடி உடுத்தி, திருமண் காப்புகள் தரித்து, மாத்யாஹ்நிகம் செய்து, சங்கல்பம் செய்துகொண்டு புதுப்பூணல் மாற்றிக்கொண்டு பிறகு தர்ப்பிக்கவேண்டும். பொதுவாக இது அனைவரும் சேர்ந்து ஒரு பொது இடத்தில் பண்ணப்படுவதாகும். தற்போது கால சூழலுக்கேற்ப அவரவர் தாம் உள்ள இடத்திலேயே பண்ணிக்கொள்வதால் சில முக்கிய அம்சங்களை விரிவாகப் பண்ண முடிவதில்லை.
        <br>
      பிறருக்காக காத்திருக்கவேண்டியதிருந்தால் இடைப்பட்ட நேரத்தில் பெருமாள் திருவாராதனத்தை முடித்துக்கொள்ளலாம், அனைத்தும் முடிந்தபிறகு தீர்த்தம் ஸ்வீகரித்துக்கொள்ளவேண்டும்.
        </h3>
      <br>
      <h3>வடகலை : </h3>ஶ்ரீபகவதாஜ்ஞயா ஶ்ரீமந் நாராயண ப்ரீத்யர்த்தம்<br>
      <h3>தென் கலை: </h3>ஶ்ரீ பகவதாஜ்ஞயா பகவத் கைங்கர்ய ரூபம்<br>
      <h3>ஸ்மார்த்தா : </h3>மமோபாத்ததுரிதக்ஷயத்வாரா ஶ்ரீபரமேஸ்வர ப்ரீத்யர்தம்<br>
      <h3>இங்கு சில தெய்வங்களின் பெயர்கள் கொடுக்கப்பட்டுள்ளன, அவரவருக்கு விருப்பமான தெய்வத்தின் பெயர்களையும் சேர்த்து சொல்லிக்ககொள்ளலாம்.</h3>
      <h3>எல்லோரும் சொல்லவும்:</h3>ஶ்ரீரங்க க்‌ஷேத்ரே  ஶ்ரீரங்கநாயிகா ஸமேத ஶ்ரீரங்கநாத ஸ்வாமி ஸந்நிதென<br>
      ஶ்ரீஅலர்மேல்மங்க நாயிகா ஸமேத ஶ்ரீஶ்ரீநிவாஸ ஸ்வாமி ஸந்நிதௌ<br>
      ஶ்ரீபெருந்தேவி நாயிகா ஸமேத ஶ்ரீதேவாதிராஜ ஸ்வாமி ஸந்நிதௌ <br>
      ச்ராவண்யாம் ச்ரவண நட்சத்ரே அதிதாநாம் சந்தஸாம் அயாத் யாமாத்வாய வீர்யவத்தா ஸித்தியர்த்தம் அத்யாய உபாகர்மா கரிஷ்யே. ததங்கம் காவேரி ஸ்நாநமஹம் கரிஷ்யே. ததங்கம் யஜ்ஞோபவீத தாரணம் கரிஷ்யே. ததங்கம் மண்டல தேவதா தர்பணாதீநாம் ச கரிஷ்யே.<br>
      <h3>ப்ரஹ்மசாரிகள் மட்டும் : </h3>ததங்கம் மௌஞ்சி, அஜின, தண்ட தாராணாநி ச கரிஷ்யே
      <h3>என்று சங்கல்பித்துக்கொண்டு, இடுக்கு தர்பம் இருந்தால் இடது புறம் வடக்கே எறிந்துவிடவம்.</h3>
      <h2>ப்ரஹ்மசாரிகள் மேகலை அணிய மந்த்ரம் :</h2>
      <div><img src="assets/img/Mounji.jpg" class="img2">
      ப்ரவேபாமா ப்ருஹதா மாதயந்தி ப்ரவா தேஜா ஹரிணே வவ்ருதாநா:<br>
      ஸோமஸ்யேவ மௌஜவதஸ்ய பக்க்‌ஷோ விபீதகோ ஜாக்ருவிஅயஹ்லயஅயயசாந்<br></div>
      <h2>ப்ரஹ்மாசாரிகள் மான்தோல் அணிய மந்த்ரம் : </h2>
      <div><img src="assets/img/Ajinam.jpg" class="img2">
      ருக் ஸாமாப்யாம் அபிஹிதவ் காவவ் தே ஸாமாநாவித: <br>
      ஷ்ரோத்ரம் தே சக்ரே ஆஸ்தாம் திவி பந்தா: சராசர:</div>
      <h2>ப்ரஹ்மாசாரிகள் தண்டம் ஏந்திக்கொள்ள மந்த்ரம் : </h2>
      <div><img src="assets/img/Dhandam.jpg" class="img2">
      ஏஷா க்க்‌ஷேதி ரதவீதிர் மகவா கோமதீர்ணௌ</div>
      <h2>அனைவரும் தர்பணம் செய்ய மந்த்ரம்:  </h2>
      நிறைய தீர்த்தம் சேர்த்து தர்பணம் செய்ய தோதான இடத்தை தேர்வு செய்துகொள்ளவும். ருஷி தர்பணம், தேவ தர்பணம், ப்ரஹ்ம தர்பணம், பித்ரு தர்பணம் எப்படிச் செய்வது என கீழே காட்டப்பட்டுள்ள படத்தைப் பார்த்து புரிந்துகொண்டு அந்தந்த தர்பணத்தை  அந்தந்த முறையில் பண்ணவும்.<br>
        நான்கு விதமான தீர்த்தங்கள் (தர்பண முறை) :<br>
        <div><img src="assets/img/DevaTheertham1.jpg" class="img2">1. தேவ தீர்த்தம் : உள்ளங்கையில் இருந்து கிழக்கு நோக்கி 4 விரல் நுனிகள் வழியாக தீர்த்தம் வழிந்தோடுவது</div>
       <div><img src="assets/img/PithruTheertham1.jpg" class="img2"> 2. பித்ரு தீர்த்தம் : குழிவான உள்ளங்கையில் இருந்து வலது கட்டை விரல் - ஆட்காட்டி விரல் இடைப்பட்ட வழியாக தெற்கு நோக்கி வழியவிடுவது.</div>
       <div><img src="assets/img/BrahmaTheertham1.jpg" class="img2"> 3. ப்ரஹ்ம தீர்த்தம் : இரு கை நிறைந்த தீர்த்தத்தை முன் கையை உயரே தூக்குவதன் மூலம் மேற்கில் மணிக்கட்டு, முட்டிப் பகுதியை நோக்கி வழியவிடுவது </div>
       <div><img src="assets/img/RushiTheertham1.jpg" class="img2"> 4. ருஷி தீர்த்தம் : இரு கை நிறைந்த தீர்த்தத்தை, இரு கைகளின் சுண்டு விரலுக்குக் கீழாக ஒரு துவாரத்தை ஏற்படுத்தி அதன்வழியாக விடுதல், வலது கையினால் மட்டும் விடும்போது தீர்த்தம் வடக்கு நோக்கி வழியும்.</div>
       <h3>ஒவ்வொரு தர்பணமும் மும்மூன்று முறை செய்யவேண்டும்</h3>
       <h2>Mandala Devata Tharpanam</h2>
      ச்ராவண்யாம் ச்ரவண நட்சத்ரே அதிதாநாம் சந்தஸாம் அயாத் யாமாத்வாய வீர்யதா ஸித்தியர்த்தம்<br>
        ஸ்வாத்யாய - ஆத்மக - தேவ ருஷி பித்ரு ப்ரீத்யர்த்தம் ஸாவித்ரியாதி நவ ப்ரதான தேவதானாம், அக்நியாதி விம்சதி மண்டல தேவதாநாம், ப்ரஹ்மயஜ்ஞ தேவதாநாம் ச தர்பணம் கரிஷ்யே.
      <h3>நவ ப்ரதான தேவதானாம் தர்பணம் - தேவ தர்பணம் - உபவீதி
      <br>
      <img src="assets/img/DevaTheertham1.jpg"></h3>
      <ol class="myol">
      <li>ஸாவித்ரீம் தர்ப்பயாமி</li>
      <li>  ப்ரஹ்மாணாம் தர்பயாமி</li>
       <li> ச்ரத்தாம் தர்பயாமி</li>
       <li> மேதாம் தர்பயாமி</li>
      <li>  ப்ரஜ்ஞாம் தர்பயாமி</li>
       <li> தாரணாம் தர்பயாமி</li>
       <li> சதஸஸ்பதிம் தர்பயாமி</li>
       <li> அநுமதீம் தர்பயாமி</li>
       <li> சந்தோபய: ருஷிப்ய: தர்பயாமி</li>

       <h3> அக்நியாதி விம்சதி மண்டல தேவதா தர்பணம் - உபவீதி - தொடர்ச்சி</h3>
      <li>  அக்நிம் தர்பயாமி</li>
       <li> ஆப: த்ருப்யந்து</li>
       <li> அக்நிம் தர்பயாமி</li>
        <li>மருத: த்ருப்யந்து</li>
       <li> அக்நிம் தர்ப்பயாமி</li>
      <li>  வர்மாணாம் தர்பயாமி</li>
       <li> அக்நிம் தர்பயாமி</li>
      <li>  மித்ரா வருணௌ த்ருப்யேதாம்</li>
        <li> அக்நிம் தர்பயாமி </li>
      <li>இந்த்ர ஸோமௌ த்ருப்யேதாம்</li>
      <li>இந்த்ரம் தர்பயாமி</li>
      <li>அக்நி மருதௌ த்ருப்யேதாம்</li>
      <li>பவமான ஸோமௌ த்ருப்யேதாம்</li>
      <li>ஸோமம் தர்பயாமி</li>
      <li>அக்நிம் தர்பயாமி</li>
      <li>ஸம்ஜ்ஞானம் தர்பயாமி</li>
      <li> விஸ்வேதேவா: த்ருப்யந்து:</li>
      <li>தேவதா: த்ருப்யந்து</li>
      <li> அக்நிஸ் த்ருப்யந்து</li>
      <li>விஷ்ணுஸ் த்ருப்யந்து  </li>
      <li>ப்ரஜாபதிஸ் த்ருப்யந்து</li>
      <li>ப்ரஹ்மா த்ருப்யது</li>
      <li>வேதா: த்ருப்யந்து</li>
      <li>தேவதா: த்ருப்யந்து</li>
      <li>ருஷய: த்ருப்யந்து</li>
      <li>ஸர்வாணி சந்தாம்ஸி த்ருப்யந்து</li>
      <li>ஓம்காரா: த்ருப்யந்து</li>
      <li>வஷட்காரா: த்ருப்யந்து:</li>
       <li>வ்யாஹ்ருதய: த்ருப்யந்து</li>
      <li>ஸாவித்ரீ த்ருப்யது</li>
       <li>யஜ்ஞா: த்ருப்யந்து</li>
      <li>த்யாவா ப்ருத்வீ த்ருப்யேதாம்</li>
      <li>அந்தரிக்ஷம் த்ருப்யந்து</li>
      <li>அஹோராத்ராணி த்ருப்யந்து</li>
      <li>ஸங்க்யா: த்ருப்யந்து</li>
      <li>ஸாங்க்யா: த்ருப்யந்து</li>
      <li>ஸித்தா: த்ருப்யந்து</li>
       <li>ஸாத்யர்: த்ருப்யந்து</li>
      <li>ஸமுத்ரா: த்ருப்யந்து</li>
      <li>நத்ய: த்ருப்யந்து</li>
      <li>காவ: த்ருப்யந்து</li>
      <li>கிரய: த்ருப்யந்து</li>
      <li>ஷேக்தர ஓஷதி வநஸ்பதய: த்ருப்யந்து</li>
      <li>கந்தர்வா: அப்ஸரஸ: த்ருப்யந்து</li>
      <li>நாகா: த்ருப்யந்து</li>
      <li>வயாம்ஸி த்ருப்யந்து</li>
      <li>விப்ரா: த்ருப்யந்து</li>
      <li>யக்ஷா: த்ருப்யந்து</li>
      <li>பூதாநி த்ருப்யந்து</li>
      <li>ஏவமந்தாநி த்ருப்யந்து</li>

      <h3>ருஷி தர்பணம் - ருஷிதீர்த்தத்தில் விடவேண்டும் - பூணல் மாலை </h3>
      <p><img src="assets/img/RushiTheertham1.jpg"></p>
      <li>சதார்சிநா: த்ருப்யந்து</li>
      <li>மாத்யமா: த்ருப்யந்து</li>
      <li>க்ரிஷ்நமத: த்ருப்யது</li>
      <li>விஸ்வாமித்ர: த்ருப்யது</li>
      <li>வாமதேவா: த்ருப்யது</li>
       <li>அத்ரி: த்ருப்யது</li>
       <li>பாரத்வாஜ: த்ருப்யது</li>
       <li>வாசிஷ்டா: த்ருப்யது</li>
      <li>ப்ரகத: த்ருப்யது</li>
       <li>பாவமாந்ய: த்ருப்யந்து</li>
       <li>க்ஷுத்ர சூக்தா: த்ருப்யந்து</li>
       <li>மஹா சூக்தா: த்ருப்யந்து</li>

      <h3>ஆசார்யாளுக்குத் தர்பணம். ஒவ்வொன்றும் மும்மூன்று முறை. பித்ரு தீர்த்தம் - ப்ராசீனாவீதி
      இது நமது பெற்றோருக்கான பித்ரு தர்பணம் அல்ல, ஆசார்யர்கள் அவர்களின் பித்ருக்கள் மனித வர்கத்தைச்
      சேர்ந்தவர்கள் என்பதால் ப்ராசீனாவீதியில் எள் சேர்த்து பண்ணப்படுகிறது. இதை தந்தை உயிருடன்
      உள்ளவர்களும் பண்ணுவதே சிறப்பு. ஆயினும் தந்தை இல்லாதவர்கள் மட்டுமே செய்கிறார்கள்.
      </h3>
      <p><img src="assets/img/PithruTheertham2.jpg"></p>
       <li>ஸமந்து, ஜைமினி, வைசம்பாயன, பைல, ஸூத்ர பாஷ்ய, பாரத-மஹாபாரத தர்மாசார்யா: த்ருப்யந்து:</li>
       <li>ஜானந்தி, பாஹவி, கார்க்ய, கௌதம, ஷாகல்ய, பாப்ரவ்ய, மாண்டூக்யமாண்டூக்யா: த்ருப்யந்து</li>
       <li>கார்கி, வாசக்னவி த்ருப்யந்து</li>
       <li>படபா, ப்ராதிதேயீ த்ருப்யந்து</li>
       <li>ஸுலபா, மைத்ரேயீ த்ருப்யந்து</li>
       <li>ககோளம் தர்பயாமி</li>
       <li>கௌஷீதகம் தர்பயாமி</li>
       <li>மஹாகௌஷீதகம் தர்பயாமி</li>
       <li>பாரத்வாஜம் தர்பயாமி</li>
       <li>பைங்கம் தர்பயாமி</li>
       <li>மஹா பைங்கம் தர்பயாமி</li>
       <li>ஸுஜனம் தர்பயாமி</li>
       <li>ஸாங்க்யாநம் தர்பயாமி</li>
       <li>ஐதரேயம் தர்பயாமி</li>
       <li>மஹாஐதரேயம் தர்பயாமி</li>
       <li>பாஷ்கலம் தர்பயாமி</li>
       <li>கார்க்யம் தர்பயாமி</li>
       <li>கௌதமம் தர்பயாமி</li>
       <li>ஸுஜாதவக்த்ரம் தர்பயாமி</li>
       <li>ஔதவாஹிம் தர்பயாமி</li>
       <li>மஹாஔதவாஹிம் தர்பயாமி</li>
       <li>ஔஜாமிம் தர்பயாமி</li>
       <li>சௌநகம் தர்பயாமி</li>
       <li>ஆச்வலாயநம் தர்பயாமி</li>
       <li>யே சே அந்ய ஆசார்யா: தே ஸர்வே த்ருப்யந்து, த்ருப்யந்து த்ருப்யந்து</li>
      </ol>
      <br>
<hr>
<div>
    <img src="assets/img/pavithram-in-ear.jpg" class="img2">
  <div class="hint">என்று தர்பித்தபின் பூநூலை உபவீதமாகப்
    போட்டுக்கொண்டு பவித்ரம் காதில் வைத்து
    ஆசமனம் பண்ணவேண்டியது.</div>
    </div>
    <p class="clear"></p>
    <hr>
    <div>
        <img src="assets/img/achamanam.gif">
      </div>
      <hr>
  <p class="head2">வேதாரம்பம்</p>
  <div>
      <img src="assets/img/Sankalpam.jpg" class="img2">
      <div class="hint">
    கிழக்குமுகமாக அமர்ந்து பவித்ரம் போட்டுக்கொண்டு
    வலது தொடையில் இடதுகைமேல் வலது கைவைத்து
  </div>
  <div class="prayogam">"வேதாரம்பம் கரிஷ்யே"</div>
  <div class="sans">वेदारम्भं करिष्ये ।
    </div>
  <div class="hint">என்று ஸங்கல்பம் செய்து கொண்டு
    கீழே உள்ள வேத மந்திரங்களை
    (தெரிந்தால் ஸ்வரத்துடன்) ஜபிக்கவும்.</div>
</div>
<p class="clear"></p>

  <div class="prayogam"> “ஹரி:ஓம் அக்நிமீளே ப்ரோஹிதம் யக்ஞஸ்ய
     தேவம்ருத்விஜம் ஹோதாரம் ரத்நதாதமம் ஹரி:ஓம்
     (ருக் வேதம்) <br>
     ஹரி: ஓம் இஷேத்வா ஊர்ஜேத்வா
    வாயவஸ்த்த உபாயவஸ்த தேவோவ: ஸவிதா ப்ரார்ப்பயது
     ச்ரேஷ்டதமாய கர்மணே ஹரி: ஓம்
     (ருக்  வேதம்) <br>
     ஹரி: ஓம் அக்நஆயாஹி வீதயே க்ருணாநோ
    ஹவ்யதாதயே நிஹோதா ஸத்ஸிபர்ஹிஷி ஹரி: ஓம்
    (ஸாம வேதம்) <br>
    ஹரி: ஓம் சந்நோதேவீ: அபிஷ்டயே
    ஆபோபவந்து பீதயே ச(ம்)யோரபிஸ்ரவந்துந:
    ஹரி: ஓம் (அதர்வ வேதம்)”
  </div>
  <div class="sans">
      हरि: ॐ। अग्निमीळे पुरोहितं - यज्ञस्य - देवमृत्विजम् ।
      होतारं - रत्नधातमं । हरि: ॐ।<br><hr>
      हरि: ॐ। इषेत्वा - उूर्जेत्वा - वायवस्थ - उपायवस्थ - देवोव: - सविता -
      प्रार्पयत् श्रेष्टतमाय - कर्मणे । हरि: ॐ।<br><hr>
      हरि: ॐ। अग्न आयाहि - वीतये - गृणान: - हव्यदातये ।
      निहोता - सत्सि - बर्हिषि । हरि: ॐ।<br><hr>

      हरि: ॐ। शन्नोदेवेरभिष्टये - आपोभवन्तु - पीतये - शँयोरभिस्रवन्तुन: । हरि: ॐ।
    </div>
  <div class="hint">வேதாரம்பம் முழுமையும் சொல்வதானால்
    நிறைய நேரம் ஆகும். விருப்பம் உள்ளவர்கள்
    கீழ்க்கண்ட வீடியோக்கனை ஓடச்செய்து முழுமையாக ஜபம்
    செய்யலாம்.
     </div>
<hr>
  <div class="mydiv">வடகலையார்:
  <div class="prayogam">பகவாநேவ ...ஸ்வசேஷ பூதமிதம் அத்யாய
     உபாகர்மாக்யம் கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே
     பகவாந் ஸ்வயமேவ காரிதவாந்.</div>
  <div class="hint"> என்று ஸாத்வீக த்யாகம் சொல்லவேண்டியது.</div>
  </div>
<hr>

          <img src="assets/img/shastanga-namaskaram.jpg" class="img1">

          <div class="hint">  எழுந்திருந்து ஸேவித்து </div>
          <p class="clear"></p><hr>
        <img src="assets/img/abhivathi.jpg" class="img1">

        <div class="hint">
          அபிவாதனம் பண்ணவேண்டியது.
    <br>பவித்ரம் பிரித்துப்போட்டு ஆசமனம் பண்ணறது. </div>
    <p class="clear"></p><hr>





<div>
  <img src="assets/img/kaikoopu.jpg" class="img2">
  <div class="hint">கையைக் கூப்பிக்கொண்டு சொல்லவும்</div>
</div>
<p class="clear"></p><hr>

    <div class="svk">
      அனைவரும் சொல்லலாம்.
    </div>
<div class="prayogam">
  “காயேன வாசா மனஸா இந்த்ரியைர்வா புத்யா ஆத்மனாவா ப்ரஹ்ருதே: ச்வபாவாது கரோமி
    யத்யது ஸகலம் பரஸ்மை ஸ்ரீமன்நாராயணாயேதி ஸமர்பயாமி"
       .” ஸர்வம் ஸ்ரீக்ருஷ்ணார்ப்பணமஸ்து. அச்யுதப் ப்ரீயதாம்.
</div>
<div class="sans">
  कायेन वाचा मनसेन्द्रियैर्वा ।
  <br> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
  <br> करोमि यद्यत्सकलं परस्मै ।
  <br> नारायणयेति समर्पयामि ॥
</div>
<hr>
<div class="hint"> பொதுவான இடத்தில் சென்று உபாகர்மா முடித்து
    ஆத்துக்கு வருபவர்களுக்கு ஆரத்தி எடுப்பது வழக்கம்.
    <br>
    <hr>
    இத்துடன் ஆவணியவிட்டம் முற்றுப்பெற்றது.
    </div>
<hr>
<div class="svk">பெருமாள் ஸேவித்து, பெரியவாளையும் ஸேவிக்கறது.</div>
  <div class="item"> மனம் நிறைந்த வாழ்த்துக்கள், குடும்பத்தாருடன், நோயற்ற வாழ்வு, குறைவற்ற செல்வம்,
  நீண்ட ஆயுளுடன், நிம்மதியாக வாழ எம்பெருமான் அருள்புரிய, ஆசீர்வாதங்களுடன்
  அல்லது வாழ்த்துக்களுடன் - வாத்யார்!
  <br>
  தாஸன்,<br>
  Dr.NVS </div>
<hr>
    </mat-tab>
    <mat-tab label="English">
      
<div class="bigdiv">
  As many are requesting to include Rig Veda Upakarma Procedures,
  it is given here from a book. We don't know whether it is correct or not.
  Kindly refer with some one of your Vadhyar for its correctness and follow
  and we could not hold responsible for any mistakes in this.
</div>
   <!--Star Manthrams -->
   <p class="svk">Achamanam</p>
   <div class="hint">
     </div>
   <hr>
   <div>
     <img src="assets/img/new-achamanam.gif">
   </div>
   <div class="hint">Achamanam and Praanayaamams are frequent
   actions done several times in any vaideeka karma. So,kindly use the below
   instructions and bring it in practice doing without any guide.
     </div>
     <hr>
   <div class="sans">
     ओं अच्युताय नम:। ओं अनन्ताय नम:। <br>
     ओं गोविन्दााय नम:।<br>
     <ion-grid>
       <ion-row>
         <ion-col class="sans">ओं केशवाय नम:। </ion-col>
         <ion-col class="sans">नारायणाय नम:।</ion-col>
       </ion-row>
       <ion-row>
         <ion-col class="sans">माधवाय नम:।</ion-col>
         <ion-col class="sans">गोविन्दाय नम:।</ion-col>
       </ion-row>
       <ion-row>
         <ion-col class="sans">विष्णवे नम:। </ion-col>
         <ion-col class="sans">मधुसूदनाय नम:।
          </ion-col>
       </ion-row>
       <ion-row>
         <ion-col class="sans"> त्रिविक्रमाय नम:। </ion-col>
         <ion-col class="sans">वामनाय नम:।
           </ion-col>
       </ion-row>
       <ion-row>
         <ion-col class="sans">श्रीधराय नम:। </ion-col>
         <ion-col class="sans">हृषीकेशाय नम:।
           </ion-col>
       </ion-row>
       <ion-row>
         <ion-col class="sans">पद्मनाभाय नम:। </ion-col>
         <ion-col class="sans">दामोदराय नम:।</ion-col>
       </ion-row>
     </ion-grid>
      </div>
   <hr>
   <div>
       <img src="assets/img/Praanaayaamam1.jpg" class="img2">

       <div class="hint">Sit facing East, insert two short dharbhams as seat under your legs
         </div>
     </div>
     <hr>
     <div>
       <img src="assets/img/Praanaayaamam2.jpg" class="img2">

       <div class="hint">Wear a pavithram made with two dharbhams in the Rt ring finger
 and fold two extra dharbhams along with it.
         </div>
     </div>
     <p class="clear"></p><hr>


     <div>
       <img src="assets/img/Praanaayaamam3.jpg" class="img2">

       <div class="hint" style="height: 60px;">Press the rt nostrils with rt thumb
       </div>
     </div>

     <p class="clear"></p><hr>
     <div>
       <img src="assets/img/Praanaayaamam4.jpg" class="img2">
       <div class="hint"> Fold both index and middle fingers towards inside, shut the mouth, inhale outside air through left nostril to fill your lung
 then shut the lt nostrils also using ring and little finger.
 <br>recite the below manthra thrice to complete one praaNaayaama
         </div>
     </div>
     <p class="clear"></p><hr>

     <div class="prayogam">Om bhoohu Om bhuvaha O(gu)m suvaha Om mahaha Om janaha Om thapaha Om sathyam tatsavidhurvareaNyam bhargodhevasya dheemahi
       dhiyoyonah prachodhayaadh Omaapaha jyotheerasaha amrutham brahma bhoor bhuva suvar Om</div>
     <div class="hint">
     The inner air should be released little by little and at the end touch the rt ear by little finger while
 saying the end part of the manthra 'Om'. </div>
   <hr>
   <div class="head2">ப்ராணாயாமம்</div>
   <hr>
   <div class="sans">
     ओं भू:। ओं भुव:। ओँसुव:। ओं मह:। ओं जन:। ओं तप:। ओँसत्यम्। ओं तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो न: प्रचोदयात्।
     ओमापो ज्योती रसोऽमूतं ब्रह्म भूर्भुवस्वरोम्।।
   </div>
  <hr>

   <div>
     <img src="assets/img/praanaayaamam.gif">
   </div>


   <div class="item">Vada Kalai To Start</div>
 <hr>
   <div>
     <img src="assets/img/kaikoopu.jpg" class="img2">
     <div class="hint">Keep both hands as shown  doing Namaskaram
     </div>
   </div>
 <hr>

   <div class="prayogam">Om asmath gurubhyo namaha.
 Sreemaan venkata naathaaryaha Kavithrkika kesari
 Vedaanthaacharya varyome; Sannidhattham sadhahrudhi.
 Gurubhyaha - thath gurubhyascha namovakam atheemahe
 Vruneemahecha thathraadhyau dhampathi jagadhampathi
 Swasesha bhuuthena maya sveeyai:(hi) sarva parichathai:(hi)
 Vidhathum preetam aatmaanam deva:(ha) prakramadhe swayam.</div>
     <hr>
   <div class="sans">
     ओं अस्मत्गुरुभ्या नम:। श्रीमान् वेङ्कटनाथार्य: कवितार्किककेसरी। वेवान्ताचार्यवर्यो मे सिन्नधत्तां सदाहृदि|| गुरुभ्य: तद्गुरुभ्यश्च
     नमोवाकं अधीमहे। वृणीमहे च तत्राद्यौ दम्पती जगतां पती ।। स्वशेष भूतेन मया स्वीयै: सर्वपरिच्छदै: । विधातुं प्रीतमात्मानं
     देव: प्रक्रमते स्वयम् ।।

   </div>
   <hr>
   <div class="item">Manthram Common for All </div>

   <div class="prayogam">
       Suklambharadharam vishnum sasivarnam chathur bhujam
 Prasanna vadhanam dhyayedh sarva vigna upasaanthaye.
 Yasyadhvradha vakrathyaha paarishathyaaha parassadham
 Vignam nignandhi sadhadham vishvaksenam tham aashraye.
   </div>
   <hr>
   <div class="sans">
     शुक्लाम्बरधरं विष्णुं शशिवर्णं चतुर्भुजम् । प्रसन्नवदनं ध्यायेत् सर्वविघ्नोपशान्तये ।। यस्यद्विरदवक्त्राद्या: पारिषद्या:
     पर:शतम् । विघ्नं निघ्नन्ति सततं विष्वसेनं तमाश्रये ।।

   </div>
 <hr>
   <div>
     <img src="assets/img/Sankalpam.jpg" class="img2">
     <div class="hint">keep the left hand as open in right thigh, place the right hand
 on it as closing</div>
   </div>

   <p class="clear"></p><hr>
   <div class="prayogam">Hari:(hi) Om Thath(u).<br>
     Sri Govindha Govindhagovindha Asya sri bhagavadha:(ha) Maha purushasya Sri Vishno:(ho) ajgnaya pravarthamanasya adhya brahmana:(ha) dvidhiya parardhe sri swedhavaraha kalpe vaivasvadha manvanthare kaliyuge prathame padhe
   </div>

   <div class="svk">For people in India</div>
   <div class="prayogam"> Jambhu dweepe Bharadha varshe bharadhakhande

   </div>

   <div class="svk">
       For people outside India:
       You can replace the word ‘Vishnu’ in all places for which you dont know the names of dweepam, varsham and kandam Example: Vishnu dweepe, Vishnu Varshe, Vishu Khande.

   </div>
 <hr>
   <div class="svk">Manthram continues for all</div>
   <div class="prayogam">Sakaapthe meroho dhakshine paarswe asmin varthamaanaanaam
    vyavaharike Prabhavaadhi shasti samvathsaraanaam madhye .....
     .....</div>
     <hr>
   <div class="sans">
     हरि: ओं तत् (सत्) श्रीगोविन्द गोविन्द गोविन्द। अस्य श्रीभगवत: महापुरुषस्य श्रीविष्णो: आज्ञया प्रवर्तमानस्य अद्यब्रह्मण: द्वितीयपराार्धे
     श्रीश्वेतवराहकल्पे वैवस्त्वत मन्वन्तरे कळियुगे प्रथमेपादे जम्बूद्वीपे भारतवर्षे भरतखण्डे शकाब्दे मेरो: दक्षिणेपार्श्वे
     अस्मिन् वर्तमानानां व्यवहारिकाणां प्रभवादीनां षष्टिसंवत्सराणां मध्ये
   </div>
   <p class="clear"></p>

 <hr>
   <div class="head2">
    Sankalpam for 12-08-2022 :
   </div>
   <div class="svk2">12-08-2022-Sankalpam - Audio </div>
    <audio controls>
    <source src="http://www.brahminsnet.com/upakarma/audio/12-08-2022.ogg" type="audio/ogg">
      <source src="http://www.brahminsnet.com/upakarma/audio/mp4/12-08-2022.mp4" type="audio/mp4">
  Your browser does not support the audio element.
  </audio>
   <hr>

   <div class="prayogam">

     pilva Naama Samvatsare<hr>
     dhakshinayane<hr>
     varsha ruthau<hr>
     simha mase<hr>
     sukla pakshe<hr>
     chaturdasyaam subha thithau<hr>
     sthira vaasara yukthayam<hr>
     shravaNa(21.17)  nakshatra yukthaayam<hr>
     sowbhaagya yoga yukthaayam<hr>
     karasha(7.53am)/vanija karana yukthaayam<hr>
     yevanguna visehana visishtaayam chaturdasyaam subha thithau

     </div>
   <hr>
   <div class="sans">
    .... पिल्व नाम संवत्सरे दक्षिणयने - वर्ष ऋतौ
    सिंह मासे शुक्ल पक्षे चतुर्तस्यां शुभ तिथौ वासर: स्थिर वासर युक्तायां
    श्रवण(21.27)  नक्षत्र युक्तायां  सौभाग्य योग युक्तायां 
    करश(7.53am)/वणिज करण युक्तायां एवङ्गुण विशेषण विशिष्टायां अस्यां चतुर्तस्यां शुभ तिथौ
    श्रीभगवदाज्ञया श्रीमन्नारायण प्रीत्यर्थं
   </div>

    <div class="mydiv">ஸ்ரீ-ம் (Hint:- Please keep this in mind to say as per your sampradayam wherever you find
    "Sri-m:"<br>
     <span style="background-color:yellow"> Vada Kalai :</span>
     Sri bhagavadhagnaya Sriman Narayana preethyartham,
     <br> <span style="background-color:yellow">Then Kalai : </span>
     Sri bhagavadhagnaya bhagavath kainkarya roopam,
     <br> <span style="background-color:yellow">ஸ்மார்த்தா</span>
      Mamo paatha samastha durithakshaya dwara , Sri Parameshwara preethyartham  </div>
      <div class="hint">Both kalai and Smarthaa to continue :</div>
     <p class="clear"></p>

 <hr>
   <p class="head2">Yagnopaveetha dharana sankalpam: </p>
 <hr>
   <div class="prayogam">Chrowdha smartha vidhi vihitha nithya karma anushtana yogyadha
   sidhyartham brahma thejaha abhiviruthiyartham yagnopaveetha dharanam karishye! </div>
 <div class="sans">
     मम श्रौतस्मार्त वितिविहित न्त्यिकर्म अनुष्टान योग्यता सिध्यर्थं ब्रह्मतेज:
     अभिवृद्धयर्थं यज्ञोपवीत धारणं करिष्ये।
 </div>
   <div class="hint"> (This is called sankalpam, after this leave the short
    dharbhams on your left side i.e in north) </div>
 <hr>
   <p class="head2">Yagnopaveetha dharana nyaasam :</p>
 <hr>
 <div>
     <img src="assets/img/Nyaasam1.jpg" class="img2">

     <div class="hint">Touch your fore head and tell :-</div>
     <div class="prayogam">'Yagnopaveetha dhaarana manthrasya brahmaa rushi:</div>
     <div class="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
   </div>

   <p class="clear"></p><hr>

   <div>
     <img src="assets/img/Nyaasam2.jpg" class="img2">

     <div class="hint">Touch your nose tip and tell :-</div>
     <div class="prayogam">'Anushtup chandha:(ha)'</div>
     <div class="sans">अनुष्टुप् छन्द:</div>

   </div>
   <p class="clear"></p><hr>



   <div>
     <img src="assets/img/Nyaasam3.jpg" class="img2">
     <div class="hint">Touch your chest and tell :-</div>
     <div class="prayogam">'Thrayee vidhya devadha'</div>
     <div class="sans">त्रयीविद्या देवता</div>

   </div>
   <hr>

   <div>
     <img src="assets/img/Nyaasam4.jpg" class="img2">

     <div class="hint">Roll both the palm towards your chest and tell :-
     </div>
     <div class="prayogam"> 'Yagnopaveetha dharane viniyoga:(ha)'</div>
     <div class="sans">यज्ञोपवीत धारणे विनियोग:</div>
   </div>
  <p class="head2">Yagnopaveetha dhaaranam : </p>
 <hr>
 <img src="assets/img/Poonal-BrahmaMudichu.jpg">
 <hr>
   <div>
       <img src="assets/img/poonal-position.jpg" class="img2">

       <div class="hint">Hold the ‘poonal’ as shown in the picture and tell:- </div>
 </div>
 <p class="clear"></p>
 <hr>
 <div>
     <img src="assets/img/insert-poonal.jpg" class="img2">

   <div class="prayogam">‘Yagnopaveetham - paramam - pavithram -
   prajapathe:(he) - yathsahajam - purasthath - aayushyam - agryam - prathimunjasubram -
   yagnopaveetham - bhalamasthu - theja:(ha).' </div>
 </div>
 <p class="clear"></p>
 <div class="sans">
     यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
     अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
 </div>

   <div class="hint">insert right and take out left hand to place on left shoulder
   and to hang under right hand.</div>
   <hr>
   <div>
       <img src="assets/img/pavithram-in-ear.jpg" class="img2">
       <div class="hint">Now brahmacharies should wait for a while when grahasthas are wearing the second poonal.<br>
 Grahasthas remove and put the pavithram in the right ear and do one achamanam, then wear pavitram and do one praanayamam.</div>
     </div>
     <p class="clear"></p>
 <hr>
 <div>
 <img src="assets/img/praanaayaamam.gif">
 </div>

 <hr>
   <div><img src="assets/img/sankalpam.jpg" class="img2">
   <div class="prayogam">Sri bhagavadhagnaya ..... m grahastha aasramaartham dvitheeya yagnopaveetha dhaaranam karishye! </div>
      <div class="sans">
         ग्रहस्त आश्रमार्थं िद्वतीय यज्ञोपवीत धारणं करिष्ये।
      </div>
      </div>
 <hr>
 <div>
     <img src="assets/img/Nyaasam1.jpg" class="img2">

     <div class="hint">Touch your fore head and tell :-</div>
     <div class="prayogam">'Yagnopaveetha dhaarana manthrasya brahmaa rushi:</div>
     <div class="sans">यज्ञोपवीत धारण मन्त्रस्य ब्रह्मा ऋषि:</div>
   </div>

   <p class="clear"></p><hr>

   <div>
     <img src="assets/img/Nyaasam2.jpg" class="img2">

     <div class="hint">Touch your nose tip and tell :-</div>
     <div class="prayogam">'Anushtup chandha:(ha)'</div>
     <div class="sans">अनुष्टुप् छन्द:</div>

   </div>
   <p class="clear"></p><hr>



   <div>
     <img src="assets/img/Nyaasam3.jpg" class="img2">
     <div class="hint">Touch your chest and tell :-</div>
     <div class="prayogam">'Thrayee vidhya devadha'</div>
     <div class="sans">त्रयीविद्या देवता</div>

   </div>
   <hr>

   <div>
     <img src="assets/img/Nyaasam4.jpg" class="img2">

     <div class="hint">Roll both the palm towards your chest and tell :-
     </div>
     <div class="prayogam"> 'Yagnopaveetha dharane viniyoga:(ha)'</div>
     <div class="sans">यज्ञोपवीत धारणे विनियोग:</div>
   </div>
  <p class="head2">Yagnopaveetha dhaaranam : </p>
 <hr>
 <img src="assets/img/Poonal-BrahmaMudichu.jpg">
 <hr>
   <div>
       <img src="assets/img/poonal-position.jpg" class="img2">

       <div class="hint">Hold the ‘poonal’ as shown in the picture and tell:- </div>
 </div>
 <p class="clear"></p>
 <hr>
 <div>
     <img src="assets/img/insert-poonal.jpg" class="img2">

   <div class="prayogam">‘Yagnopaveetham - paramam - pavithram -
   prajapathe:(he) - yathsahajam - purasthath - aayushyam - agryam - prathimunjasubram -
   yagnopaveetham - bhalamasthu - theja:(ha).' </div>
 </div>
 <p class="clear"></p>
 <div class="sans">
     यज्ञोपवीतम् परमं पवित्रं प्रजापते: यत्सहजं पुरस्तात् आयुष्यं
     अग्रियं प्रतिमञ्चशुभ्रं यज्ञोपवीतं बलमस्तु तेज:
 </div>

   <div class="hint">insert right and take out left hand to place on left shoulder
   and to hang under right hand.</div>
   <hr>



   <div class="hint">Now brahmacharies & grahasthas remove the old poonal by saying :
 </div>
   <div class="prayogam">“Upaveetham - bhinnadhanthum - jeernam - kasmaladhooshitham - visrujami -
 jalebrahmannu - varcha:(ha) - dheerghayu:(hu) - ashthume!” </div>
     <div class="sans">
         उपवीतं भिन्नतन्तुं जीर्णं कश्मलदूषितम्।<br>
         विसृजामि जले ब्रह्मन् वर्च: दीर्घायु: अस्तु मे।।
     </div>
 <hr>
 <div>
     <img src="assets/img/pavithram-in-ear.jpg" class="img2">
   <div class="hint"> After removing the old poonal, put the pavithram in the right ear
   do one achamanam </div>
     </div>
     <img src="assets/img/new-achamanam.gif">

     div class="mydiv">
     <div class="svk">'kamokarsheet japam' is not instructed or not in practice
     for Rig Vedins</div>

 <p class="clear"></p>
 <br>
<!--Start Manthrams-->
<br> Note:- Each tharpanam should be done thrice.
<h2>Mandala Devata Tharpanam</h2>
<p>SrAvaNyaam shravaNa-nakshatre adheetaanaam veeryataa-siddhyartham<br>
  svAdhyAya-Atmaka-deva-rshi-pitR-prItyartham sAvitryAdinava-<br>
  pradhAna-devatAnAm agnyAdi-vimSati-maNDala-devatAnAm<br>
  brahma-yajna-devatAnAm ca tarpaNam karishye</p>
<h3>Nava Pradhaana Devataanaam Tarpanam Deva Deertham Upaveethi:<br>
 (Keep the poonal as usual)
<br>
<img src="assets/img/DevaTheertham1.jpg"></h3>
<ol class="myol">
  <li>saavithreem tharpayami</li>
<li> brahmaaNam tharpayami</li>
<li> shradhaam tharpayami </li>
<li> medhaam tharpayami</li>
<li> prajgnaam tharpayaami</li>
<li> dhaaranaam tharpayaami</li>
<li> sadhasaspathim tharpayaami</li>
<li> anumatheem tharpayaami</li>
<li> chandhobhya: rushibhya: tharpayaami</li>
</ol>
<br>
<h3>agniyaati vimsati mandala devataa tarpanam<br>
Keep poonal as it is in upaveeti</h3>
<ol class="myol">
  <li>agnim tarpayaami</li>
  <li>  aapa: thrupyantu</li>
    <li>agnim tarpayaami</li>
    <li>maruta: thrupyantu</li>
<li>    agnim tarpayaami</li>
<li>    varmaaNam tarpayaami</li>
<li>    agnim tarpayaami</li>
<li>    mitraavaruNau thrupyetaam</li>
<li>    agnim tarpayaami</li>
<li>    indra, somau thrupyetaam</li>
<li>    indram tarpayaami</li>
<li>    agni, marutau thrupyetaam</li>
<li>    pavamaana, somau thrupyetaam</li>
<li>    somam tarpayaami</li>
<li>    agnim tarpayaami</li>
<li>    samjgnaanam tarpayaami</li>
<li>    vishvadevaa: thrupyantu</li>
<li>    devata: thrupyantu</li>
<li>    agnis thrupyantu</li>
<li>    viShNus thrupyantu  </li><li>prajaapatis thrupyatu</li>
<li>    brahmaa thrupyatu</li>
<li>    vedaa: thrupyantu</li>
<li>    devaa: thrupyantu</li>
<li>    rushaya: thrupyantu</li>
<li>    sarvaaNi chandaa(ng)msi thrupyantu</li>
<li>    omkaara: thrupyatu</li>
<li>    vashatkaara: thrupyatu</li>
 <li>   vyaahrutaya: thrupyantu</li>
<li>    saavitree thrupyatu</li>
 <li>   yajgna: thrupyantu</li>
<li>    dhyaavaa pruthvee thrupyetaam</li>
<li>    anthariksham thrupyatu</li>
<li>    aho-raatraaNi thrupyantu</li>
<li>    sankhyaa: thrupyantu</li>
<li>    saankhyaa: thrupyantu</li>
<li>    siddhaa: thrupyantu</li>
 <li>   saadhyaa: thrupyantu</li>
<li>    samudraa: thrupyantu</li>
<li>    nadya: thrupyantu</li>
<li>    gaava: thrupyantu</li>
  <li>giraya: thrupyantu</li>
<li>    kshetroushadhi-vanaspataya: thrupyantu</li>
  <li>gandharvaa:-apsarasa: thrupyantu</li>
<li>    naagaa: thrupyantu</li>
 <li>   vayaamsi thrupyantu</li>
<li>    vipraa: thrupyantu</li>
<li>    yakshaa: thrupyantu</li>
<li>    bhoothaani thrupyantu</li>
<li>    evamanthaani thrupyantu</li>

</ol>
<h2>Rishi Tharpanam</h2>
<h3>Risheenaam Tarpanam Rushi Deertham niveethi:<br>
  wear the poonal as a garland
</h3>
<p><img src="assets/img/RushiTheertham1.jpg">
  <ol class="myol">
<li>shatarcinaH tR^ipyantu</li>
    <li>mAdhyamAH tR^ipyantu</li>
    <li>gR^isnamadaH tR^ipyatu</li>
<li>    vishvAmitraH tR^ipyatu</li>
<li>    vAmadevaH tR^ipyatu</li>
 <li>   atriH tR^ipyatu</li>
 <li>   bharadvAjaH tR^ipyatu</li>
 <li>   vasiShThaH tR^ipyatu</li>
<li>    pragAthAH tR^ipyantu</li>
 <li>   pAvamAnyaH tR^ipyantu</li>
 <li>   kshudra-sUktAH tR^ipyantu</li>
 <li>   mahA-sUktAH tR^ipyantu</li>
</ol>
<h2>Achaaryaanaam Tarpanam</h2>
<h3>Achaaryaanaam Tarpanam (EACH LINE TO BE REPEATED THREE TIMES)<br>
  Praacheenaaveethi (YAJNOPAVITAM ON OPPOSITE SIDE). Pitru Deertham<br>
  This tarpanam can be done by persons who is having father alive<br>
  bedause there is no name their pitru in this, they are rushis.
</h3>
  <img src="assets/img/PithruTheertham2.jpg">

<ol class="myol">
 <li> sumantu jaimini-vaishampAyana-paila-sUtrabhAShya-bhAratamahAbhArata-
   dharmAcAryAH tR^ipyantu</li>
 <li>jAnanti-bAhavi-gArgya-gautama-shakalya-bAbhravya-mANDUkyamANDukeyAH</li>
 <li>   tR^ipyantu</li>
 <li>   gArgI vAcaknavI tR^ipyatu</li>
 <li>   baDabAH prAtitheyI tR^ipyatu</li>
 <li>   sulabhA maitreyi tR^ipyatu</li>
 <li>   kahoLam tarpayAmi</li>
 <li>   kauShItakam tarpayAmi</li>
 <li>   mahAkauShItakam tarpayAmi</li>
 <li>   bharadvAjam tarpayAmi</li>
 <li>   pai~Ngam tarpayAmi</li>
 <li>   mahApai~Ngam tarpayAmi</li>
 <li>   suyajnam tarpayAmi</li>
 <li>   sAnkhyAyanam tarpayAmi</li>
 <li>   aitareyam tarpayAmi</li>
 <li>   mahaitareyam tarpayAmi</li>
 <li>   bAShkalam tarpayAmi</li>
 <li>   gArgyam tarpayAmi</li>
 <li>   gautamam tarpayAmi</li>
 <li>   sujAtavaktram tarpayAmi</li>
 <li>   audavAhim tarpayAmi</li>
 <li>   mahaudavAhim tarpayAmi </li>
 <li>aujAmim tarpayAmi</li>
 <li>   shaunakam tarpayAmi</li>
 <li>   AshvalAyanam tarpayAmi</li>
 <li>   ye ca anye AcAryAH te sarve tR^ipyantu tR^ipyantu tR^ipyantu
 </li>
</ol>

   <!-- End Manthrams-->

   <hr>
   <div>
       <img src="assets/img/pavithram-in-ear.jpg" class="img2">
     <div class="hint">Kaandarushi tharpanam over! Next Vedha Aarambham.
      If you are doing it in your house, keep the pavithram in
      your right ear and do achamanam. If you are doing it in
      the bank of a river or a lake remove
     and untie  the pavithram and do achamanam twice.</div>
       </div>
       <p class="clear"></p>
       <hr>
       <div>
           <img src="assets/img/new-achamanam.gif">
         </div>
         <hr>
     <p class="head2">Vedha - Aarambham</p>
     <div>
         <img src="assets/img/Sankalpam.jpg" class="img2">
         <div class="hint">
       Sit in a clean place towards east. Chant the below manthrams.
       Here under given some common vedarambam mantrams for all,
    specific vedaramba mantras will be updated if it is found.
     </div>
     <div class="prayogam">"Vedhaarambam karishye"</div>
     <div class="sans">वेदारम्भं करिष्ये ।
       </div>
     <div class="hint">after this sankalpam,
     chant the below veda mantras with its swaram
     if you know well.</div>
   </div>
   <p class="clear"></p>

     <div class="prayogam">
     “Hari: Om - Agnimeele purohitham - yagnasya - dhevamruvijammm-
      hothaaaram - rathnadhathamam - hari: Om”<br>
   “Hari: Om - Yishethvaaa - oorjethvaaa- vayavastha -
   upayavastha - dhevovaha - prarpayathu - sreshtathamaya -
   karmane - hari: Om”<br>
   “Hari: Om - Agnaaayhi - veedhayeaaa- grunana:(ha) -
   havyadhathayeaa - nihotha - sathsi bharhishi - hari: Om”<br>
   “Hari: Om - Sannodhevi: - abhishtayeaa - aapobhavanthu -
    peethayeaaa - saymyo:(ho) - abhisravanthuna: (ha) - hari: Om”<br>

     </div>
     <div class="sans">
         हरि: ॐ। अग्निमीळे पुरोहितं - यज्ञस्य - देवमृत्विजम् ।
         होतारं - रत्नधातमं । हरि: ॐ।<br><hr>
         हरि: ॐ। इषेत्वा - उूर्जेत्वा - वायवस्थ - उपायवस्थ - देवोव: - सविता -
         प्रार्पयत् श्रेष्टतमाय - कर्मणे । हरि: ॐ।<br><hr>
         हरि: ॐ। अग्न आयाहि - वीतये - गृणान: - हव्यदातये ।
         निहोता - सत्सि - बर्हिषि । हरि: ॐ।<br><hr>

         हरि: ॐ। शन्नोदेवेरभिष्टये - आपोभवन्तु - पीतये - शँयोरभिस्रवन्तुन: । हरि: ॐ।
       </div>
     
   <hr>
     <div class="mydiv">Vadakalai only should say :-
     <div class="prayogam">
     “Bhagavaneva swasesha
     bhoothamidham upakarmakyam karma swasmai
     swapreethaye bhagavan swayameva kaarithavaan”</div>
     <div class="hint">If anybody still wearing the pavithram,
     remove and untie it and throw it.
      All should do achamanam twice.</div>
     </div>
   <hr>

             <img src="assets/img/shastanga-namaskaram.jpg" class="img1">

           <div class="hint">
             get up and do namaskaram as per sampradayam
              </div>
              <p class="clear"></p><hr>
           <img src="assets/img/abhivathi.jpg" class="img1">

           <div class="hint">
             do abhivadhi.</div>
             <p class="clear"></p><hr>

    <hr>



   <div>
     <img src="assets/img/kaikoopu.jpg" class="img2">
     <div class="hint">Keep hands as doing namaskaram and  tell</div>
   </div>
   <p class="clear"></p><hr>
       <hr>
       <div class="svk">
         all can recite
       </div>
   <div class="prayogam">
     ”
    “Kaayena vaacha - manase -
    indhriyarvaa - bhudhya - athmanaava - prahrudhe:(he) - swabhavaadh -
     karomi - yathyadh - sakalam - parasmai - sriman naarayanayethi - samarpayami”
   “Sarvam Sri Krishnarpanam asthu. Achydha preeyatham”.
   </div>
   <div class="sans">
     कायेन वाचा मनसेन्द्रियैर्वा ।
     <br> बुद्ध्यात्मना वा प्रकृतिस्वभावात् ।
     <br> करोमि यद्यत्सकलं परस्मै ।
     <br> नारायणयेति समर्पयामि ॥
   </div>
   <hr>
   <div class="hint">
   If you did the upakarma
   in a common place and returnin to house, ask the ladies to take harathi.

       <hr>
       This is the end of Upakarma.
       </div>
   <hr>
   <div class="svk">First you go to the perumal (pooja) room and do namaskaram to permal
   and then do namaskaram to periyavals (elders).
    If possible call relatives and friends to your house and
    take food with them. Enjoy this day.</div>
     <div class="item"> I pray Emperuman to bless all your family
     with good health and longivity with all desirable good things
     throughout your life. Be happy with parents, relatives and friends.
     Blessings or Wishses.
     <br>
    Dasan<br>
     Vadhyar - Dr.NVS </div>
   <hr>
    </mat-tab>
  </mat-tab-group>`;

const RigUpakarmaPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ருக் உபாகர்மா - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default RigUpakarmaPage;
